<template>
  <iframe
    :src="src"
    sandbox="allow-popups allow-forms allow-same-origin allow-scripts allow-top-navigation allow-top-navigation-by-user-activation allow-downloads"
    :style="{
      display: 'block',
      border: 'none',
      width: '100%',
      height: '100%',
      overflow: 'auto'
    }"
  />
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    type: {
      type: String,
      required: true,
      validator: (value) => ['confirm_order', 'order_summary', 'send_tracking'].includes(value)
    }
  },
  computed: {
    ...mapGetters({
      currentLang: 'currentLang'
    }),
    src() {
      return `https://cms.enterprise.zwiz.app/${this.currentLang}/message-template-iframe/config?type=${this.type}`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/MessageTemplateConfigIframe.vue